<template>
  <header>
    <ul
      class="navigation"
      :class="$route.name === 'Main' ? 'container-fluid' : 'container'"
    >
      <li class="nav">
        <a href="#" @click.prevent="$emit('openNavigation', true)">
          <span class="hamb">
            <i></i>
            <i></i>
            <i></i>
          </span>
        </a>
      </li>
      <li class="local-nav">
        <template v-if="$route.name !== 'FirstPage'">
          <!-- <router-link
            style="overflow-y: hidden; overflow-x: hidden"
            v-if="currentSection && !$route.params.section"
            :to="{
              name: 'MovieList',
              params: {
                section: currentSection.id,
                collection: currentSection.collections[0].id,
              },
            }"
          >
            <svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </router-link> -->
          <a
            style="overflow-y: hidden; overflow-x: hidden"
            v-if="currentSection && !$route.params.section"
            @click="routeBack"
          >
            <svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </a>
          <router-link
            v-else-if="$route.params.section"
            style="overflow-y: hidden; overflow-x: hidden"
            :to="{ name: 'Main' }"
            ><svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </router-link>
          <router-link
            v-else-if="$router.currentRoute.name === 'Press'"
            style="overflow-y: hidden; overflow-x: hidden"
            :to="{ name: 'FirstPage' }"
            ><svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </router-link>
          <router-link
            v-else-if="$router.currentRoute.name === 'PressNumber'"
            style="overflow-y: hidden; overflow-x: hidden"
            :to="{ name: 'Press' }"
            ><svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </router-link>
          <router-link
            v-else-if="$router.currentRoute.name === 'ShopItem'"
            style="overflow-y: hidden; overflow-x: hidden"
            :to="{
              name: 'ShopCategory',
              params: { category: $route.params.category },
            }"
            ><svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </router-link>
          <router-link
            v-else-if="$router.currentRoute.name === 'ShopCategory'"
            style="overflow-y: hidden; overflow-x: hidden"
            :to="{
              name: 'Shop',
            }"
            ><svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </router-link>
          <router-link
            v-else-if="$router.currentRoute.name === 'PlaneInfo'"
            style="overflow-y: hidden; overflow-x: hidden"
            :to="{
              name: 'FlightInfo',
            }"
            ><svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </router-link>
          <router-link
            v-else-if="
              $router.currentRoute.name === 'Main' ||
              $router.currentRoute.name === 'About' ||
              $router.currentRoute.name === 'FlightInfo' ||
              $router.currentRoute.name === 'Help' ||
              $router.currentRoute.name === 'Privacy' ||
              $router.currentRoute.name === 'License' ||
              $router.currentRoute.name === 'bonus' ||
              $router.currentRoute.name === 'Services' ||
              $router.currentRoute.name === 'Menu' ||
              $router.currentRoute.name === 'UpgradeSeat' ||
              $router.currentRoute.name === 'Shop' ||
              $router.currentRoute.name === 'ShopCard' ||
              $router.currentRoute.name === 'Feedback'
            "
            style="overflow-y: hidden; overflow-x: hidden"
            :to="{ name: 'FirstPage' }"
            ><svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </router-link>
          <router-link
            v-else-if="$router.currentRoute.name === 'PressItem'"
            style="overflow-y: hidden; overflow-x: hidden"
            :to="{
              name: 'PressNumber',
              params: { number: $route.params.number },
            }"
          >
            <svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </router-link>
          <router-link
            v-else-if="$router.currentRoute.name !== 'Index'"
            style="overflow-y: hidden; overflow-x: hidden"
            :to="{ name: 'Index' }"
          >
            <svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="icon-arr-back"
            >
              <path
                d="M0.703125 10.2031L9.70312 1.25C10.125 0.78125 10.8281 0.78125 11.2969 1.25C11.7188 1.67188 11.7188 2.375 11.2969 2.79688L3.04688 11L11.25 19.25C11.7188 19.6719 11.7188 20.375 11.25 20.7969C10.8281 21.2656 10.125 21.2656 9.70312 20.7969L0.703125 11.7969C0.234375 11.375 0.234375 10.6719 0.703125 10.2031Z"
                fill="#194589"
              />
            </svg>
          </router-link>
        </template>
      </li>
      <li class="route">
        <!-- <RouteBar
          :flightInfo="flightInfo"
          :class="{ hidden: !flightInfo.legs }"
        /> -->
      </li>
      <li class="basket">
        <!-- <router-link to="/shop/card"
          ><svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            id="icon-basket"
          >
            <rect width="36" height="36" rx="18" fill="#194589" />
            <path
              d="M 27.294 11.024 L 11.652 11.024 L 11.306 9.333 C 11.229 8.911 10.845 8.565 10.422 8.565 L 6.579 8.565 C 6.31 8.565 6.118 8.795 6.118 9.026 L 6.118 9.948 C 6.118 10.217 6.31 10.41 6.579 10.41 L 9.654 10.41 L 12.306 24.091 C 11.883 24.553 11.652 25.129 11.652 25.782 C 11.652 27.166 12.728 28.242 14.112 28.242 C 15.457 28.242 16.572 27.166 16.572 25.782 C 16.572 25.436 16.418 24.898 16.226 24.553 L 21.798 24.553 C 21.606 24.898 21.491 25.436 21.491 25.782 C 21.491 27.166 22.567 28.242 23.95 28.242 C 25.296 28.242 26.41 27.166 26.41 25.782 C 26.41 25.091 26.103 24.476 25.641 24.014 L 25.68 23.861 C 25.795 23.284 25.372 22.708 24.758 22.708 L 13.92 22.708 L 13.574 20.863 L 25.565 20.863 C 26.026 20.863 26.372 20.594 26.487 20.171 L 28.216 12.177 C 28.332 11.601 27.909 11.024 27.294 11.024 Z M 14.112 26.705 C 13.574 26.705 13.19 26.32 13.19 25.782 C 13.19 25.283 13.574 24.86 14.112 24.86 C 14.611 24.86 15.034 25.283 15.034 25.782 C 15.034 26.32 14.611 26.705 14.112 26.705 Z M 23.95 26.705 C 23.412 26.705 23.028 26.32 23.028 25.782 C 23.028 25.283 23.412 24.86 23.95 24.86 C 24.45 24.86 24.873 25.283 24.873 25.782 C 24.873 26.32 24.45 26.705 23.95 26.705 Z M 24.834 19.018 L 13.19 19.018 L 11.998 12.869 L 26.18 12.869 L 24.834 19.018 Z"
              fill="white"
              style=""
            />
          </svg>
          <i v-if="shopCard.length">{{ shopCard.length }}</i></router-link
        > -->
      </li>
      <li class="help">
        <router-link class="button" to="/feedback" v-if="isBox">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            id="icon-help"
          >
            <rect width="36" height="36" rx="18" fill="#194589" />
            <path
              d="M18 26V26.0391C16.5156 26.0391 15.1484 25.7656 13.8984 25.3359C13.4688 25.6484 12.6875 26.1172 11.7891 26.5078C10.8516 26.9375 9.71875 27.2891 8.625 27.2891C8.35156 27.2891 8.11719 27.1328 8.03906 26.8984C7.92188 26.6641 8 26.3906 8.15625 26.1953C8.19531 26.1953 8.19531 26.1562 8.23438 26.1562C8.27344 26.0781 8.35156 26 8.42969 25.9219C8.58594 25.7266 8.78125 25.4141 9.01562 25.0625C9.40625 24.4375 9.75781 23.5781 9.83594 22.6016C8.66406 21.2734 8 19.6719 8 17.875C8 13.4219 12.4531 9.75 18 9.75C23.5078 9.75 28 13.4219 28 17.875C28 22.3672 23.5078 26 18 26ZM13.9375 15.375C13.3906 15.375 13 15.8047 13 16.3125C13 16.8594 13.3906 17.25 13.9375 17.25H22.0625C22.5703 17.25 23 16.8594 23 16.3125C23 15.8047 22.5703 15.375 22.0625 15.375H13.9375ZM13.9375 19.125C13.3906 19.125 13 19.5547 13 20.0625C13 20.6094 13.3906 21 13.9375 21H18.3125C18.8203 21 19.25 20.6094 19.25 20.0625C19.25 19.5547 18.8203 19.125 18.3125 19.125H13.9375Z"
              fill="white"
            />
          </svg>
        </router-link>
      </li>
      <li class="attendant">
        <!-- <a href="#" @click.prevent="showModal">
          <svg 
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            id="icon-attendant"
          >
            <rect width="36" height="36" rx="18" fill="#194589" />
            <path
              d="M18.5625 11.25C20.1158 11.25 21.375 9.9908 21.375 8.4375C21.375 6.8842 20.1158 5.625 18.5625 5.625C17.0092 5.625 15.75 6.8842 15.75 8.4375C15.75 9.9908 17.0092 11.25 18.5625 11.25Z"
              fill="white"
              stroke="white"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22.5631 18.7327C22.5631 18.7327 22.5631 26.249 22.5631 27.3852C22.5631 28.5214 23.4065 29.25 24.2331 29.25C25.0598 29.25 25.875 28.6962 25.875 27.3415C25.875 25.9868 25.875 18.7764 25.875 17.684C25.875 16.5915 25.1788 14.625 22.8293 14.625C20.4798 14.625 15.0846 14.625 15.0846 14.625C12.9091 14.625 12.8221 15.1494 12.2129 16.1982C11.6038 17.247 11.0382 18.5579 10.6466 19.3008C10.255 20.0437 9.29779 20.1311 8.25355 20.1311C7.20932 20.1311 7.16581 20.1311 5.64297 20.1311C4.12013 20.1311 4.03311 23.1901 5.90403 23.1901C7.77495 23.1901 9.53709 23.1901 11.1687 23.1901C13.0501 23.1901 14.2131 20.2096 14.2131 20.2096L14.2144 27.7785H22.5875"
              fill="white"
            />
          </svg>
        </a> -->
      </li>

      <li class="logo">
        <router-link to="/">
          <picture>
            <source
              v-if="$i18n.locale === 'ru' && theme === 'light'"
              srcset="@/assets/i/AFL_logo_RU_blue.png"
              media="(max-width: 767px)"
            />
            <source
              v-else-if="$i18n.locale !== 'ru' && theme === 'light'"
              srcset="@/assets/i/AFL_logo_EN_blue.png"
              media="(max-width: 767px)"
            />
            <source
              v-else-if="$i18n.locale === 'ru' && theme === 'dark'"
              srcset="@/assets/i/AFL_logo_RU_white.png"
              media="(max-width: 767px)"
            />
            <source
              v-else-if="$i18n.locale !== 'ru' && theme === 'dark'"
              srcset="@/assets/i/AFL_logo_EN_white.png"
              media="(max-width: 767px)"
            />
            <img
              v-if="$i18n.locale === 'ru' && theme === 'light'"
              src="~@/assets/i/AFL_logo_RU_blue.png"
              alt=""
              class="logo"
            />
            <img
              v-else-if="$i18n.locale !== 'ru' && theme === 'light'"
              src="~@/assets/i/AFL_logo_EN_blue.png"
              alt=""
              class="logo"
            />
            <img
              v-else-if="$i18n.locale === 'ru' && theme === 'dark'"
              src="~@/assets/i/AFL_logo_RU_white.png"
              alt=""
              class="logo"
            />
            <img
              v-else-if="$i18n.locale !== 'ru' && theme === 'dark'"
              src="~@/assets/i/AFL_logo_EN_white.png"
              alt=""
              class="logo"
            />
          </picture>
        </router-link>
      </li>
    </ul>
    <OrderHeader></OrderHeader>
  </header>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import RouteBar from "@/components/RouteBar";
import flight from "@/mixins/flight";
import connectLink from "@/mixins/connectLink";
import OrderHeader from "@/components/popup/OrderHeader";

export default {
  name: "HeaderCore",
  //   components: { RouteBar, OrderHeader },
  components: { OrderHeader },
  mixins: [flight, connectLink],
  computed: {
    ...mapState("section", {
      indexSectionData: (state) => state.index,
      indexSectionLoading: (state) => state.indexLoading,
    }),
    ...mapState("content", {
      contentData: (state) => state.content,
      indexContentLoading: (state) => state.indexLoading,
    }),
    ...mapState("audio", {
      audioContentData: (state) => state.newContent,
    }),
    ...mapState("shop", {
      shopCard: (state) => state.card,
    }),
    ...mapState("settings", {
      theme: (state) => state.theme,
    }),
    currentSection() {
      if (this.$route.params.section) {
        return this.indexSectionData.find(
          (item) => item.id === +this.$route.params.section
        );
      } else if (+this.$route.params.id === this.contentData.id) {
        const section = this.contentData.collections.find((it) => it.isSection);
        if (section) {
          return this.indexSectionData.find(
            (item) => item.id === section.collectionId
          );
        }
      } else if (+this.$route.params.id === this.audioContentData.id) {
        const section = this.audioContentData.collections.find(
          (it) => it.isSection
        );
        if (section) {
          return this.indexSectionData.find(
            (item) => item.id === section.collectionId
          );
        }
      }
      return false;
    },
  },
  methods: {
    ...mapActions("order", {
      showModal: "showModal",
    }),
    ...mapActions({
      setLocale: "SET_LOCALE",
    }),
    routeBack() {
      window.history.back();
    },
  },
};
</script>

<style></style>
